module.exports = __webpack_public_path__ + "276efef02a3d2714644dd3659792e6e4.png";